import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DefaultMatCalendarRangeStrategy, MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AlertModalComponent } from '@app/components/alert-modal/alert-modal.component';
import { AppIconComponent } from '@app/components/app-icon/app-icon.component';
import { AuthFooterComponent } from '@app/components/auth-footer/auth-footer.component';
import { BrowserExtensionCardComponent } from '@app/components/browser-extension-card/browser-extension-card.component';
import { ConnectorCardComponent } from '@app/components/connector-card/connector-card.component';
import { FormModalComponent } from '@app/components/form-modal/form-modal.component';
import { InviteMembersModalComponent } from '@app/components/invite-members-modal/invite-members-modal.component';
import { ManageWorkspacePopupComponent } from '@app/components/manage-workspace-popup/manage-workspace-popup.component';
import { NotificationsPanelComponent } from '@app/components/notifications-panel/notifications-panel.component';
import { PopoverComponent } from '@app/components/popover/popover.component';
import { PopupComponent } from '@app/components/popup/popup.component';
import { ScrollableTabsComponent } from '@app/components/scrollable-tabs/scrollable-tabs.component';
import { SearchBarComponent } from '@app/layouts/app-search-bar/app-search-bar.component';
import { GlobalHeaderComponent } from '@app/layouts/global-header/global-header.component';
import { HeaderBarComponent } from '@app/layouts/header-bar/header-bar.component';
import { MainMenuComponent } from '@app/layouts/main-menu/main-menu.component';
import { DashboardComponent } from '@app/pages/dashboard/dashboard.component';
import { NgbCollapseModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SearchResultsFiltersComponent } from '@pages/search/search-results-filters/search-results-filters.component';
import { CustomDomSanitizer } from '@services/custom-sanitizer';
import { MarkdownModule } from 'ngx-markdown';
import { NgxMasonryModule } from 'ngx-masonry';
import { TimeagoModule } from 'ngx-timeago';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { HideIfPausedOrCancelledDirective } from './directives/hide-if-paused-or-cancelled.directive';
import { SpaceUserActionDirective } from './directives/space-user-action.directive';
import { MatModulesModule } from './mat-modules/mat-modules.module';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
  declarations: [
    AlertModalComponent,
    BrowserExtensionCardComponent,
    ConnectorCardComponent,
    AuthFooterComponent,
    DashboardComponent,
    FormModalComponent,
    GlobalHeaderComponent,
    HeaderBarComponent,
    MainMenuComponent,
    ManageWorkspacePopupComponent,
    PopupComponent,
    ScrollableTabsComponent,
    SearchBarComponent,
    SearchResultsFiltersComponent,
    HideIfPausedOrCancelledDirective,
    InviteMembersModalComponent,
    SpaceUserActionDirective,
  ],
  imports: [
    AppIconComponent,
    AvatarGroupModule,
    AvatarModule,
    OverlayModule,
    NgxMasonryModule,
    ProgressSpinnerModule,
    TooltipModule,
    DialogModule,
    RouterModule,
    CommonModule,
    FormsModule,
    MarkdownModule.forRoot({ loader: HttpClient }),
    NgbCollapseModule,
    NgbDropdownModule,
    NgbTooltipModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    NgOptimizedImage,
    MatModulesModule,
    PipesModule,
    SelectModule,
    RadioButtonModule,
    SkeletonModule,
    ScrollPanelModule,
    PopoverModule,
    AccordionModule,
    NotificationsPanelComponent,
    PopoverComponent,
    TimeagoModule,
  ],
  exports: [
    AlertModalComponent,
    AppIconComponent,
    AvatarGroupModule,
    AvatarModule,
    BrowserExtensionCardComponent,
    ConnectorCardComponent,
    DashboardComponent,
    AuthFooterComponent,
    DialogModule,
    FormsModule,
    GlobalHeaderComponent,
    HeaderBarComponent,
    MainMenuComponent,
    MarkdownModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgxMasonryModule,
    PopupComponent,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollableTabsComponent,
    SearchBarComponent,
    SearchResultsFiltersComponent,
    TimeagoModule,
    TooltipModule,
    TranslateModule,
    OverlayModule,
    HideIfPausedOrCancelledDirective,
    NgOptimizedImage,
    MatModulesModule,
    PipesModule,
    InviteMembersModalComponent,
    SelectModule,
    RadioButtonModule,
    SkeletonModule,
    ScrollPanelModule,
    SpaceUserActionDirective,
    ManageWorkspacePopupComponent,
    PopoverModule,
    AccordionModule,
  ],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultMatCalendarRangeStrategy,
    },
    {
      provide: DomSanitizer,
      useClass: CustomDomSanitizer,
    },
  ],
})
export class SharedModule {}
